exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Titillium+Web);", ""]);

// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"background-color": "#fff",
	"menu-icon-color": "#999"
};